import {ContentRoute} from "../../../models/Route";
import ExecuteTaskList from "./executeTaskList";
import ExecuteTaskForm from "./executeTaskForm";
import enumDescription from "../../../services/enumDescription";
import ExecuteTaskAnalysisForm from "./executeTaskAnalysisForm";

export enum TypeExecuteTask {
    TYPE_TEST_USER   = 1,
    TYPE_JOB = 2,
    TYPE_AI_TEST = 3
}

export const TypeExecuteTaskList = new enumDescription(  [
    {   value: TypeExecuteTask.TYPE_TEST_USER, description: 'Execução Manual'    },
    {   value: TypeExecuteTask.TYPE_JOB, description: 'Execução Programada (Job)'    },
    {   value: TypeExecuteTask.TYPE_AI_TEST, description: 'Teste de IA'    }
]);

export enum StackExecuteTask {
    SELENIUM          = 1,
    CYPRESS           = 2,
    AGENT_DEVELOPERS  = 3
}

export const StackExecuteTaskList = new enumDescription(  [
    {   value: StackExecuteTask.SELENIUM,         description: 'Selenium'           },
    {   value: StackExecuteTask.CYPRESS,          description: 'Cypress'            }
]);

export const StackExecuteTaskAIList = new enumDescription(  [
    {   value: StackExecuteTask.AGENT_DEVELOPERS, description: 'Agent Developers'  }
]);

export enum StatusExecuteTask {
    STATUS_IN_CONFIGURATION = 1,
    STATUS_WAITING = 2,
    STATUS_EXECUTING = 3,
    STATUS_FINISH = 4
}

export const StatusExecuteTaskList = new enumDescription(  [
    {value: StatusExecuteTask.STATUS_IN_CONFIGURATION, description: 'Configurando'},
    {value: StatusExecuteTask.STATUS_WAITING, description: 'Aguardando Execução'},
    {value: StatusExecuteTask.STATUS_EXECUTING, description: 'Executando'},
    {value: StatusExecuteTask.STATUS_FINISH, description: 'Finalizado'}
]);

export enum TypeExecuteTaskResult {
    STATUS_EXECUTANDO   = 1,
    STATUS_FINALIZADO   = 2,
    STATUS_AGUARDANDO   = 3,
    STATUS_CANCELADO    = 4,
    STATUS_INTERROMPIDO = 5
}

export const TypeExecuteTaskResultList = new enumDescription(  [
    {   value: TypeExecuteTaskResult.STATUS_AGUARDANDO, description: 'Na fila'},
    {   value: TypeExecuteTaskResult.STATUS_EXECUTANDO, description: 'Executando'},
    {   value: TypeExecuteTaskResult.STATUS_FINALIZADO, description: 'Finalizado'},
    {   value: TypeExecuteTaskResult.STATUS_CANCELADO, description: 'Cancelado'},
    {   value: TypeExecuteTaskResult.STATUS_INTERROMPIDO, description: 'Interrompido'}
]);

// Quantos casos o admin deixa rodando ao mesmo tempo no modo simultâneo (acima do recomendado a tela pede confirmação)
export const LIMITE_SIMULTANEO_PADRAO = 5;
export const LIMITE_SIMULTANEO_RECOMENDADO = 5;
export const LIMITE_SIMULTANEO_MAXIMO = 20;

/** Na fila ou executando: a tela continua acompanhando enquanto houver algum */
export const STATUS_RESULTADO_ATIVOS = [TypeExecuteTaskResult.STATUS_AGUARDANDO, TypeExecuteTaskResult.STATUS_EXECUTANDO];



export const execute_task_content_routes: Array<ContentRoute> = [
    {
        'path':'/execute-task',
        'description': 'Execuções de Testes',
        'exact':true,
        'component': ExecuteTaskList,
        'menu': true
    },
    {
        'path':'/execute-task/incluir',
        'description': 'Novo Plano de Execução',
        'exact':true,
        'component': ExecuteTaskForm,
        'menu': false
    },
    {
        'path':'/execute-task/alterar/:id',
        'description': 'Alterar Plano de Execução',
        'exact':true,
        'component': ExecuteTaskForm,
        'menu': false
    },
    {
        'path':'/execute-task/execute/:id',
        'description': 'Execução e Resultados',
        'exact':true,
        'component': ExecuteTaskAnalysisForm,
        'menu': false
    }
]